import { createCustomXmlIdentityStore } from "../shared/customXmlIdentity";

// Excel's route to the <jyloCheckOut> stamp: Excel.customXmlParts (ExcelApi 1.5),
// which is the same API shape PowerPoint exposes, so the loop itself lives in
// ../shared/customXmlIdentity and this file is just the two host-specific bindings.
//
// The stamp is written by the API when the draft is served -- the same
// DraftCheckOutMetadataStamper code path stamps .xlsx as it does .docx -- so a
// workbook checked out of Jylo already carries its identity and nothing server-side
// had to change for Excel.

const store = createCustomXmlIdentityStore<Excel.RequestContext, Excel.CustomXmlPart>({
  hostName: "Excel",
  run: (callback) => Excel.run(callback),
  parts: (context) => context.workbook.customXmlParts,
});

export const readCheckOutIdentity = store.read;
export const writeCheckOutIdentity = store.write;
